import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useInView } from '@/hooks/useInView';
import { services } from '@/data/products';

const CALENDLY_URL = 'https://calendly.com/hello-kingmakersinc/discovery';

function RevealSection({ children, className = '', delay = 0 }) {
  const [ref, isInView] = useInView();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${className}`}
      style={{
        opacity: isInView ? 1 : 0,
        transform: isInView ? 'translateY(0)' : 'translateY(24px)',
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}

export default function Services() {
  return (
    <div data-testid="services-page" className="px-6 lg:px-8 pt-[80px] pb-[100px] md:pt-[120px] md:pb-[120px]">
      <div className="max-w-3xl mx-auto">
        <RevealSection>
          <p className="font-inter text-xs font-semibold tracking-[0.25em] uppercase text-km-gold mb-4">Advisory Services</p>
          <h1 className="font-inter font-bold text-[38px] md:text-[54px] lg:text-[68px] leading-[1.1] tracking-tight text-km-white">
            Coming soon.
          </h1>
          <p className="mt-6 font-inter font-medium text-base md:text-lg text-km-gray-5 leading-[1.3]">
            Consulting engagements start with a{' '}
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-km-gold hover:text-km-gold-deep transition-colors cursor-pointer"
            >
              discovery call
            </a>
            .
          </p>
        </RevealSection>

        <RevealSection delay={100}>
          <div className="mt-16 space-y-[20px]">
            {services.map((service) => (
              <div
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className="p-[30px] rounded-[10px] border border-km-gray-3 bg-km-gray-2"
              >
                <h2 className="font-inter font-medium text-[20px] leading-[1.2] text-km-white">{service.name}</h2>
                <p className="mt-2 font-inter font-medium text-base text-km-gray-5 leading-[1.3]">{service.tagline}</p>
                <span className="inline-flex items-center mt-4 px-2.5 py-1 rounded-full border border-km-gray-4/50 bg-km-gray-4/20 font-inter text-[10px] font-semibold tracking-[0.15em] uppercase text-km-gray-5">
                  Coming Soon
                </span>
              </div>
            ))}
          </div>
        </RevealSection>

        <RevealSection delay={200}>
          <div className="mt-16 p-8 md:p-12 rounded-[10px] bg-km-card-gradient border-2 border-km-gold/30 text-center">
            <h2 className="font-inter font-medium text-[20px] md:text-[24px] leading-[1.2] text-km-white">In the meantime</h2>
            <p className="mt-3 font-inter font-medium text-base text-km-gray-5 leading-[1.3] max-w-md mx-auto">
              The High-Stakes Narrative Pack is available now. Start building clarity today.
            </p>
            <Link
              to="/products/high-stakes-narrative-pack"
              data-testid="services-product-cta"
              className="mt-6 inline-flex items-center gap-2 px-8 py-3.5 rounded-[10px] bg-km-gold text-km-gray-1 font-inter font-medium text-sm tracking-wide hover:bg-km-gold-deep transition-colors duration-300 cursor-pointer"
            >
              Get the Narrative Pack <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </RevealSection>
      </div>
    </div>
  );
}
